<template>
  <div>
    <div @click="toggleDropdown" class="dropdown-toggle nav-item">
      {{ MyCategory.FormKbn.find((item) => item.Kbn == 1)?.KbnName }}
    </div>
    <StaffSelect
      :isModalStaffSelectVisible="isModalStaffSelectVisible"
      :staffSelectId="StaffSelectId"
      @selected-action="selectedActionStaffSelect"
      @cancel-action="cancelActionStaffSelect"
    />
    <div v-if="isOpen" class="dropdown-menu">
      <div
        v-for="(staffRole, index) in StaffRole.filter((item:TblMStaffRole) => item.kbn == 1 && item.roleKbn ==1)"
        :key="index"
      >
        <router-link
          :to="staffRole.url ?? ''"
          class="dropdown-item"
          @click="closeDropdown"
          >{{ staffRole.menuName }}</router-link
        >
      </div>

      <router-link
        to="/role"
        class="dropdown-item"
        @click="closeDropdown"
        v-if="companyService.role && companyService.role.includes('Admin')"
        >役割</router-link
      >

      <!-- <router-link to="/serviceUsageTable" class="dropdown-item" @click="closeDropdown">サービス提供表</router-link>
       <router-link to="/visitingNurseRecordII" class="dropdown-item" @click="closeDropdown">訪問看護記録書Ⅱ</router-link>
      <router-link to="/visitingNursePlan" class="dropdown-item" @click="closeDropdown">訪問看護計画書</router-link>
      <router-link to="/visitingNurseReport" class="dropdown-item" @click="closeDropdown">訪問看護報告書</router-link>
      <router-link to="/counter" class="dropdown-item" @click="closeDropdown">Counter</router-link>
      <router-link to="/fetch-data" class="dropdown-item" @click="closeDropdown">Fetch data</router-link>
      <router-link to="/fileupload" class="dropdown-item" @click="closeDropdown">FileUpload</router-link>
      <router-link to="/pdf" class="dropdown-item" @click="closeDropdown">PDF</router-link>
      <router-link to="/myFullCalendar" class="dropdown-item" @click="closeDropdown">FullCalendar</router-link> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import type { Ref } from "vue";
import { RouterLink } from "vue-router";
import CompanyService from "../Js/CompanyService";
import StaffSelect from "@/components/StaffSelect.vue";
import { useStaffSelect } from "@/Js/StaffSelectService";
import StaffSelectService from "@/Js/StaffSelectService";
import MyCategory from "@/Data/MyCategory";
import { TblMStaffRole } from "@/models/TblMStaffRole";
import type { ITblMStaffRoleData } from "@/models/TblMStaffRole";
import axios, { Axios, type AxiosResponse } from "axios";

const companyService = CompanyService; //会社情報、既にexport default new CompanyService();をしている。
const staffSelectService = new StaffSelectService();
const StaffRole: Ref<TblMStaffRole[]> = ref([new TblMStaffRole()]);

const {
  StaffSelectId,
  isModalStaffSelectVisible,
  showStaffSelect,
  closeModalStaffSelect,
  cancelActionStaffSelect,
  selectedActionStaffSelect,
} = useStaffSelect();

const openStaffSelect = async () => {
  await showStaffSelect(() => {
    isOpen.value = !isOpen.value;
  });
};

const isOpen = ref(false);

const props = defineProps({
  isOpenMenu1: Boolean,
});

const toggleDropdown = async() => {
  const company = companyService.getStoredData();
  if (
    company.companyCode != "" &&
    company.officeCode != "" &&
    company.serviceType != ""
  ) {
    if ((staffSelectService.getStaffSelect() ?? "") == "") {
      await openStaffSelect();
    } else {
      isOpen.value = !isOpen.value;
    }
    await getList();
  }
};

const closeDropdown = () => {
  isOpen.value = false;
};

const getList = async () => {
  try {

    const staffCode = staffSelectService.getStaffSelect() ;
    if (staffCode && StaffRole.value.length==0) {
      const endpoint: string = `${
        import.meta.env.VITE_API_TARGET
      }/api/MStaffRole/GetListsByStaffCode/${
        staffCode ?? ""
      }`;

      const response = await axios.get(endpoint);
      let staffRole: TblMStaffRole[] = [new TblMStaffRole()];

      if (response.status === 200) {
        staffRole = response.data.map((item: TblMStaffRole) => {

          // 新しいユーザーオブジェクトを作成し、変換された日付を使用
          return new TblMStaffRole({
            ...item,
           });
        });

        StaffRole.value=staffRole;
      }
    }
  } catch{

  }
};

const redirectToManage = () => {
  closeDropdown();
  window.location.href = `${import.meta.env.VITE_API_TARGET}/Identity/Account/Manage`;
};

onMounted(async () => {
  StaffRole.value =[];
});

watch(
  () => props.isOpenMenu1,
  (newValue, oldValue) => {
    if (newValue !== oldValue && newValue == true) {
      isOpen.value = false;
    }
  }
);
</script>

<style scoped>
.dropdown-toggle {
  cursor: pointer;
  padding: 8px;
  background-color: #007bff;
  color: white;
}

.dropdown-menu {
  position: fixed;
  display: block;
  background-color: white;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  max-height: 50vh;
  overflow-y: auto;
  z-index: 9000 !important;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}
</style>
